export default "__VITE_ASSET__CJVhbXGO__"